import { EventType, InteractionRequiredAuthError } from '@azure/msal-browser';
import { arrayAny } from '../utils/arrayUtils';

export const SetupInstance = (instance) =>{

    instance.enableAccountStorageEvents();

    // Default to using the first account if no account is active on page load
    if (!instance.getActiveAccount() && arrayAny(instance.getAllAccounts())) {
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        instance.setActiveAccount(instance.getAllAccounts()[0]);
    }

    instance.addEventCallback((event) => {
        if (
            (event.eventType === EventType.LOGIN_SUCCESS ||
                event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
                event.eventType === EventType.SSO_SILENT_SUCCESS) &&
            event.payload && event.payload.account
        ) {
            instance.setActiveAccount(event.payload.account);
        }

        // Surface auth interaction requirements (e.g. expired session) to the UI
        // so the app can show a friendly "session expired" prompt instead of
        // immediately redirecting.
        if (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE && event.error instanceof InteractionRequiredAuthError) {
            try {
                const detail = {
                    message: event.error.message,
                    errorCode: event.error.errorCode,
                    path: window.location.pathname + window.location.search + window.location.hash
                };
                window.dispatchEvent(new CustomEvent('pm_auth_interaction_required', { detail }));
            } catch (_e) {
                // ignore dispatch issues; UI will just not get the hint
            }
        }
    });

    return instance;
};